import { RootState } from '..';
import { SpecificationDto } from './specification';
import { SpecificationsState } from './specifications.reducer';

export const selectSpecifications = (state: RootState) =>
  state.specifications.specifications;

export const selectFilteredSpecifications = (state: RootState) =>
  state.specifications.filteredSpecifications;

export const selectSpecificationsBy = (
  state: SpecificationsState,
  func: (s: SpecificationDto) => boolean
) => state.specifications.filter(func);

export const selectSpecificationsRequestState = (state: RootState) =>
  state.specifications.requestState;
